import { Factory } from 'rosie';

Factory.define('InboxesAdmin').attr('name', 'INBOXES_ADMIN');

Factory.define('InboxesAdminWithDefaults').extend('InboxesAdmin');



// WEBPACK FOOTER //
// ./factories/location/inboxes_admin.js